import { useEffect, useState } from 'react';
import useAuth from './useAuth';
import { ROLE_NAMES } from '../util/const';
import axios from '../axios-default';

const useThreeShapeOnRole = () => {
    const [threeshapeConnected, setThreeshapeConnected] = useState(false);
    const auth = useAuth();

    useEffect(() => {
        if (auth.user.role === ROLE_NAMES.doctor && !threeshapeConnected) {
            const threeShapeLogin = async () => {
                try {
                    let { data } = await axios.get(`/threeshape/check_connect`);
                    if (data.success) {
                        setThreeshapeConnected(true);
                    } else {
                        setThreeshapeConnected(false);
                    }
                } catch (error) {
                    setThreeshapeConnected(false);
                }
            };
            threeShapeLogin();
        }
    }, [auth.user.role, threeshapeConnected]);

    return {
        threeshapeConnected,
        setThreeshapeConnected,
    };
};

export default useThreeShapeOnRole;
